import React, { createContext, useContext, useEffect, useState, useReducer } from 'react'
import { Table, Button, Input,  Select, Modal , Form,  Checkbox, DatePicker, Badge, Space,} from 'antd'
import { StateContext } from '../../../state';
import http from '../../../../../utils/server'
import { SearchOutlined,ExclamationCircleOutlined } from '@ant-design/icons';
import { Mode } from '../../../../../App';
import Draggable from 'react-draggable';
import './index.less'
import DeviceNew from '../Device/addNew';
import DeviceFix from '../Device/update';
import { DeviceContext } from '../Device/index';
var changeDev = false;
const AreaContext = createContext();

function formatDateTimes(inputTime) {
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  };


function DeviceManage() {
    const { actArea} = useContext(AreaContext)
    const [form] = Form.useForm()
    const { state, dispatch } = useContext(StateContext)
    const [actDevice, dispatchDevice] = useReducer((state, action) => {
        if (action.type === 'update') {
            return action.device
        } else if (action.type === 'clear') {
            let now = new Date();
            now.setFullYear(now.getFullYear() + 1);
            return {
                name: '测点',//测点名称
                type: 201,//主机类型
                sn: '',
                sim: '',
                m_name: '',
                node: 1,
                district: '',
                humi: 0,
                hide: 0,
                door_alarm: 0,
                power_alarm: 0,
                location: 2,
                status: 0,
                expire: now,
                time: new Date(),
                iccid_expire:new Date('2000-01-01'),
                iccid:''
            }
        }
        return state
    }, []);
    const [showNewModel, setShowNewModel] = useState(false)
    const [showFixModel, setShowFixModel] = useState(false)
    const [tableData, setTableData] = useState([])
    const [modalBounds,setModalBounds] = useState({left: 0, top: 0, bottom: 0, right: 0 });//对话框移动坐标
    const [modalMoveDisabled, setModalMoveDisabled] = useState(true);//对话框拖动功能关闭
    const [selDevCID,setSelDevCID] = useState(0);
    const [showDevC,setShowDevC] = useState(false);
    const [devCustom ,setDevCustom] = useState('');
    const draggleRef = React.createRef();//对话框移动
    const nodeSerch = React.createRef();
    const devSerch = React.createRef();
    const simSerch = React.createRef();
    useEffect(() => {
        http.get("/v1/device", {}).then(data => {
            if (data.code === 0) {
                setTableData(data.data.filter(x=>x.district===actArea.id).sort((a,b)=>a.sn-b.sn));
                dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) });
            }
        })
        http.get("/v1/devicetype", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'devicetype', devicetype: data.data });
            }
        })
    }, [])

    // 对话框移动方法
    const onStart = (event, uiData) => {
        const { clientWidth, clientHeight } = window.document.documentElement;
        const targetRect = draggleRef.current?.getBoundingClientRect();
        if (!targetRect) return;
        setModalBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        });
    };

    const columns = [
        
        //测点名称
        {
            title: '测点名称',
            dataIndex: 'name',
            // key: 'id',
            align: 'center',
            render: (value, record) => (
                <div>
                    <div>
                        {
                            record.name
                        }
                    </div>
                    <div style={{ fontSize: 10, color: '#666' }}>
                        {
                            'ID:' + ((record.node * 1 < 10) ? '0' + record.node : record.node)
                        }
                    </div>
                </div>
            ),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
            (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={nodeSerch}
                        placeholder='设备信息'
                        value={selectedKeys[0]}
                        onChange={e => {
                            let val = e.target.value;
                            setSelectedKeys(val ? [val] : [])
                        }}
                        onPressEnter={() => confirm()}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button size="small" style={{ width: 90 }} onClick={() => {
                            clearFilters()
                        }}>
                            重置
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => confirm()}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            查找
                        </Button>

                    </Space>
                </div>
            ),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                  setTimeout(() => nodeSerch.current.focus({cursor: 'all'}), 100);//全选
                }
              },
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,

            onFilter: (value, record) =>{
                return record['node']||record['name']? 
                (record['node'].toString().toLowerCase().includes(value.toLowerCase()) ||
                record['name'].toLowerCase().includes(value.toLowerCase()))
                : ''
            }
                ,
        },
        //主机名称
        {
            title: '主机名称',
            dataIndex: 'm_name',
            // key: 'id',
            align: 'center',
            render: (value, record) => (
                <div>
                    <div>
                        {
                            record.m_name
                        }
                    </div>
                    <div style={{ fontSize: 10, color: '#666' }}>
                        {
                            record.sn
                        }
                    </div>
                </div>
            ),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
            (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={devSerch}
                        placeholder='主机名称'
                        value={selectedKeys[0]}
                        onChange={e => {
                            setSelectedKeys(e.target.value ? [e.target.value] : [])
                        }}
                        onPressEnter={() => confirm()}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button size="small" style={{ width: 90 }} onClick={() => {
                            clearFilters()
                        }}>
                            重置
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => confirm()}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            查找
                        </Button>

                    </Space>
                </div>
            ),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                  setTimeout(() => devSerch.current.focus({cursor: 'all'}), 100);
                }
              },
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,

            onFilter: (value, record) =>
                record['m_name']||record['sn']
                    ? record['m_name'].toString().toLowerCase().includes(value.toLowerCase())||record['sn'].toString().toLowerCase().includes(value.toLowerCase())
                    : '',
        },
        //设备类型
        {
            title: '设备类型',
            dataIndex: 'type',
            width:100,
            // key: 'id',
            align: 'center',
            sorter: {
                compare:(a, b) => a.type - b.type,
                multiple: 5,
            },
            render: (text, record) => (
                <div>
                    {
                        state.devicetype.filter(x => { return x.code === record.type }).length > 0 ? state.devicetype.filter(x => { return x.code === record.type })[0].value : '无'
                    }
                </div>
            )
        },
        //SIM卡号
        {
            title: 'SIM卡号',
            width:130,
            dataIndex: 'sim',
            // key: 'id',
            align: 'center',
            sorter: {
                compare: (a, b) => a.sim - b.sim,
                multiple: 1,
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
            (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={simSerch}
                        placeholder='sim卡号'
                        value={selectedKeys[0]}
                        onChange={e => {
                            setSelectedKeys(e.target.value ? [e.target.value] : [])
                        }}
                        onPressEnter={() => confirm()}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button size="small" style={{ width: 90 }} onClick={() => {
                            clearFilters();
                        }}>
                            重置
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => confirm()}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            查找
                        </Button>

                    </Space>
                </div>
            ),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                  setTimeout(() => simSerch.current.focus({cursor: 'all'}), 100);
                }
              },
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,

            onFilter: (value, record) =>
                record['sim']
                ? record['sim'].includes(value)
                : '',
        },
        //添加时间
        // {
        //     title: '添加时间',
        //     dataIndex: 'time',
        //     width:100,
        //     // key: 'id',
        //     align: 'center',
        //     sorter:{
        //         compare: (a, b) => Date.parse(a.time.replace(/T|Z/g, ' ').trim()) - Date.parse(b.time.replace(/T|Z/g, ' ').trim()),
        //         multiple: 2,
        //     },
        //     render:(text, record)=>text= text.slice(0,10)
            
        // },
        //设备到期时间
        {
            title: '到期时间',
            dataIndex: 'expire',
            width:100,
            align: 'center',
            sorter: {
                compare:(a, b) => Date.parse(a.expire.replace(/T|Z/g, ' ').trim()) - Date.parse(b.expire.replace(/T|Z/g, ' ').trim()),
                multiple: 3,
            },
            render:(text, record)=>text= text.slice(0,10),
        },
        //卡到期时间
        {
            title: '卡到期时间',
            dataIndex: 'iccid_expire',
            width:100,
            align: 'center',
            sorter: {
                compare:(a, b) => Date.parse(a.iccid_expire.replace(/T|Z/g, ' ').trim()) - Date.parse(b.iccid_expire.replace(/T|Z/g, ' ').trim()),
                multiple: 3,
            },
            render:(text, record)=>text= text?text.slice(0,10):'',
        },
        //状态
        {
            title: '状态',
            dataIndex: 'expirestatus',
            width:80,
            align: 'center',
            sorter: {
                compare:(a, b) => Date.parse(a.expire.replace(/T|Z/g, ' ').trim()) - Date.parse(b.expire.replace(/T|Z/g, ' ').trim()),
                multiple: 4,
            },
            render: (text, record) => {
                let days = parseInt((new Date(record.expire).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24);
                return (
                <div>
                    {
                        days < 0 ? '已到期' : days < 30 ? '即将到期' : '正常'
                    }
                </div>
            )},
            filters: [
                {
                    text: '正常',
                    value: 2
                },
                {
                    text: '即将到期',
                    value: 1
                },
                {
                    text: '已到期',
                    value: 0
                },
            ],
            // filteredValue: defFilter ,
            onFilter: (value, record) => {
                if (value === 2) return parseInt((new Date(record.expire).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24) >= 30;
                if (value === 1) return (parseInt((new Date(record.expire).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24) >= 0 && parseInt((new Date(record.expire).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24) < 30);
                if (value === 0) return parseInt((new Date(record.expire).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24) < 0;
            },
        },
        {
            title: 'IMEI',
            dataIndex: 'imei',
            align: 'center',
            width:100,
        },
        {
            title: '备注',
            dataIndex: 'custom',
            align: 'center',
            width:100,
        },
        {
            title: '操作',
            width: 150,
            dataIndex: 'operation',
            key: 'id',
            align: 'center',
            render: (text, record) => (
                <div>
                    {/* 修改按钮 */}
                    <Button size='small' style={{ marginLeft: '10px' }} type="primary" onClick={() => {
                        setShowFixModel(true)
                        changeDev = true;
                        dispatchDevice({ type: 'update', device: record })
                    }}>
                        修改
                    </Button>
                    {/* 删除按钮 */}
                    <Button size='small' type='primary' danger style={{ marginLeft: '10px' }} onClick={() => {
                        Modal.confirm({
                            centered: true,
                            title: `确定要删除设备${record.name}吗？`,
                            icon: <ExclamationCircleOutlined />,
                            content: `编号:${record.sn}测点:${record.node}删除之后将不可恢复！！`,
                            okText: '删除',
                            okType: 'danger',
                            cancelText: '取消',
                            onOk() {
                                http.delete("/v1/device/" + record.id, { data: record }).then((data) => {
                                    http.get("/v1/device", {}).then(data => {
                                        if (data.code === 0) {
                                            dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) })
                                            setTableData(data.data.filter(x=>x.district===actArea.id).sort((a,b)=>a.sn-b.sn))
                                        }
                                    })
                                })
                            },
                            onCancel() {
                                console.log('Cancel');
                            },
                        });
                    }}>
                        删除
                    </Button>
                    {
                        Mode==='soc'&& state.main.type<102 &&
                        <Button size='small' type='primary'  style={{ marginLeft: '5px' ,borderRadius:10}} onClick={()=>{
                            setShowDevC(true)
                            setSelDevCID(record.id)
                            setDevCustom(record.custom)
                        }}>
                            备注
                        </Button>
                    }
                </div>
            ),
        },
    ]
    const onfinish = (values) => {
        console.log('values',values);
        const {cardedittime,simauto,cardedittimeauto,iccid1,simdate,...newvalues} = values
        if (changeDev) {
            http.put("/v1/device/" + actDevice.id, {
                ...newvalues,
                parent:Mode==='soc'?actArea.user_name:'',
                district:actArea.id,
                status: actDevice.status, node: Number(values.node),
                sn: Number(values.sn),
                humi: values.humi ? 1 : 0,
                door_alarm: values.door_alarm ? 1 : 0,
                hide: values.hide ? 1 : 0,
                power_alarm: values.power_alarm ? 1 : 0,
                expire: values.expire?values.expire.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.expire),
                time:values.time ? values.time.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.time),
                iccid_expire:values.iccid_expire ? values.iccid_expire.format("YYYY-MM-DD 00:00:00"):actDevice.iccid_expire,
                imei:actDevice.iccid_expire,
                custom:actDevice.custom,
                upSn:actDevice.upSn
            }).then((data) => {
                http.get("/v1/device", {}).then(data => {
                    if (data.code === 0) {
                        dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) })
                        setTableData(data.data.filter(x=>x.district===actArea.id).sort((a,b)=>a.sn-b.sn))
                    }
                })
            })
        } else {
            http.post("/v1/device", {
                ...newvalues,
                parent:Mode==='soc'?actArea.user_name:'',
                district:actArea.id,
                node: Number(values.node),
                sn: Number(values.sn),
                humi: values.humi ? 1 : 0,
                door_alarm: values.door_alarm ? 1 : 0,
                power_alarm: values.power_alarm ? 1 : 0,
                hide: values.hide ? 1 : 0,
                status: values.status ? 1 : 0,
                expire: values.expire?values.expire.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.expire),
                time:values.time ? values.time.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.time),
                iccid_expire:values.iccid_expire ? values.iccid_expire.format("YYYY-MM-DD 00:00:00"):actDevice.iccid_expire+' 00:00:00',
            }).then((data) => {
                http.get("/v1/device", {}).then(data => {
                    if (data.code === 0) {
                        dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) });
                        setTableData(data.data.filter(x=>x.district===actArea.id).sort((a,b)=>a.sn-b.sn))
                    }
                })
            })
        }
    }
    return (
        <div style={{ padding: 10 }}>
           <div style={{display:'flex'}}>
                {Mode==='soc'&&<div style={{paddingLeft:20}}><span>用户名称: </span>{actArea.user_name}</div>}
                <div style={{paddingLeft:20}}><span>区域名称: </span>{actArea.name}</div>
           </div>
            <div style={{ float: 'right', marginBottom: 10 }}>
                {
                    state.main.type<103&&
                    <Button style={{ backgroundColor: 'green', color: '#fff', borderRadius: 5 }}
                        onClick={() => {
                            setShowNewModel(true)
                            dispatchDevice({ type: 'clear'})
                        }}>新建设备
                    </Button>
                }
            </div>
            <Table bordered pagination={{ hideOnSinglePage: true }} rowKey={record => record.id}  size='small' dataSource={tableData} 
                rowClassName={record=>record.status===1&&'socDevice'}
                columns={Mode==='soc'?state.main.type>100?columns.filter(x=>x.title!=='卡到期时间'&&x.title!=='IMEI'&&x.title!=='备注'):columns
                    :columns.filter(x=>x.title!=='到期时间'&&x.title!=='卡到期时间'&&x.title!=='状态'&&x.title!=='IMEI'&&x.title!=='备注')} 
            />

            <Modal maskClosable={false} title={
                    <div
                    style={{
                        width: '100%',
                        cursor: 'move',
                    }}
                    onMouseOver={() => {
                        setModalMoveDisabled(false);
                    }}
                    onMouseOut={() => {
                        setModalMoveDisabled(true);
                    }}
                    >
                    新增设备
                    </div>
                } visible={showNewModel}
                destroyOnClose style={{cursor:'move'}}
                modalRender={modal => (
                    <Draggable
                        disabled={modalMoveDisabled}
                        bounds={modalBounds}
                        onStart={onStart}
                    >
                      <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
                cancelText='取消'
                width={600}
                okText='确定'
                onOk={() => {
                    form.submit();
                    
                }}
                onCancel={() => {
                    setShowNewModel(false)
                    dispatchDevice({ type: 'clear' })
                }}>
                <DeviceContext.Provider value={{ actDevice, dispatchDevice, form, onfinish }}>
                    <DeviceNew  isShowUser={false}/>
                </DeviceContext.Provider>
            </Modal>
            <Modal maskClosable={false} title={
                    <div
                    style={{
                        width: '100%',
                        cursor: 'move',
                    }}
                    onMouseOver={() => {
                        setModalMoveDisabled(false);
                    }}
                    onMouseOut={() => {
                        setModalMoveDisabled(true);
                    }}
                    >
                    修改设备
                    </div>
                } visible={showFixModel}
                destroyOnClose style={{cursor:'move'}}
                modalRender={modal => (
                    <Draggable
                        disabled={modalMoveDisabled}
                        bounds={modalBounds}
                        onStart={onStart}
                    >
                      <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
                cancelText='取消'
                width={600}
                okText='确定'
                onOk={() => {
                    form.submit()
                }}
                onCancel={() => {
                    setShowFixModel(false)
                    changeDev = false;
                    dispatchDevice({ type: 'clear' })
                }}>
                <DeviceContext.Provider value={{ actDevice, dispatchDevice, form, onfinish }}>
                    <DeviceFix  isShowUser={false}/>
                </DeviceContext.Provider>
            </Modal>
            <Modal maskClosable={false} title={
                    <div
                    style={{
                        width: '100%',
                        cursor: 'move',
                    }}
                    onMouseOver={() => {
                        setModalMoveDisabled(false);
                    }}
                    onMouseOut={() => {
                        setModalMoveDisabled(true);
                    }}
                    >
                    设备备注
                    </div>
                }  visible={showDevC}
                destroyOnClose style={{cursor: 'move'}}
                modalRender={modal => (
                    <Draggable
                      disabled={modalMoveDisabled}
                      bounds={modalBounds}
                      onStart={onStart}
                    >
                      <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
                cancelText='取消'
                // footer={false}
                width={600}
                okText='确定'
                onOk={() => {
                    http.post("/v1/devicecustom/"+selDevCID, {
                        custom:devCustom
                    }).then(res=>{
                        http.get("/v1/device", {}).then(data => {
                            if (data.code === 0) {
                                dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) })
                                // let temp=[];
                                // if(selDis.length===0&&selUser===0){
                                //     temp=data.data;
                                // }else if(selDis.length===0&&selUser!==0){
                                //     let userDis = state.district.filter(x=>x.user===selUser);
                                //     findUserDis(selUser,state.systemuser.list,state.district,userDis);
                                //     userDis.map(item=>{
                                //         temp= temp.concat(data.data.filter(x=>x.district === item.id));
                                //     })
                                // }else if(selDis.length>0){
                                //     selDis.map(item=>{
                                //         temp= temp.concat(data.data.filter(x=>x.district === item));
                                //     })
                                // }
                                setTableData(data.data);
                            }
                        })
                        setShowDevC(false)
                    })
                }}
                onCancel={() => {
                    setShowDevC(false)
                }}>
                <div>
                    <Input placeholder = '备注内容' value={devCustom} onChange={e=>{
                        setDevCustom(e.target.value)
                    }}/>
                </div>
            </Modal>
        </div>
    )
}


function AreaNew() {
    const { actArea, dispatchArea } = useContext(AreaContext)
    const { state } = useContext(StateContext)
    return (
        <div>
            <Input style={{ marginBottom: 5 }} addonBefore="区域名称" value={actArea.name} autoFocus
                onChange={(e) => { dispatchArea({ type: 'update', area: { ...actArea, name: e.target.value } }) }} 
                onKeyDown={e=>{
                    if(e.key==='Enter'){

                    }
                }}
            />
        </div>
    )
}

function AreaManage(props) {
    const [form] = Form.useForm();
    const { state, dispatch } = useContext(StateContext);
    const [actArea, dispatchArea] = useReducer((state, action) => {
        if (action.type === 'update') {
            return action.area
        } else if (action.type === 'clear') {
            return {
                name: '',
            }
        }
        return state
    }, []);
    const [actDevice, dispatchDevice] = useReducer((state, action) => {
        if (action.type === 'update') {
            return action.device
        } else if (action.type === 'clear') {
            let now = new Date();
            Mode==='soc'?now.setFullYear(now.getFullYear() + 1):now.setFullYear(now.getFullYear() + 100);
            return {
                name: '测点',//测点名称
                type: 201,//主机类型
                sn: '',
                sim: '',
                m_name: '',
                node: 1,
                district: action.district,
                humi: 0,
                hide: 0,
                door_alarm: 0,
                power_alarm: 0,
                location: 2,
                status: 0,
                expire: now,
                time: new Date(),
                iccid_expire:new Date('2000-01-01'),
                iccid:'0',
                cardedittime:new Date(),
            }
        }
        return state
    }, []);
    const [showNewModel, setShowNewModel] = useState(false);
    const [showFixModel, setShowFixModel] = useState(false);
    const [showNewDevModel, setShowNewDevModel] = useState(false);//添加设备对话框
    const [devMangerModel, setDevMangerModel] = useState(false);//设备管理对话框

    useEffect(() => {
        http.get("/v1/district", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'district', district: data.data })
            }
        })
        http.get("/v1/device", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'device', device: data.data })
            }
        })
        Mode==='soc'&&http.get("/v1/users", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'systemuser', systemuser: data.data.sort((a,b)=>a.name.localeCompare(b.name,'zh')) })
            }
        })
    }, [])

    const columns = [
        {
            title: '区域名称',
            dataIndex: 'name',
            // key: 'id',
            align: 'left',
            with: '300',
        },
        {
            title: '设备数量',
            align:'center',
            width:'100',
            render:(text,record)=>(
                <div style={{cursor:'pointer'}} onClick={()=>{
                    setDevMangerModel(true);
                    dispatchArea({type: 'update', area: record})
                    }} >
                    <Badge overflowCount={99999} showZero count={state.device.filter(x=>x.district===record.id&&x.node!==0).length} style={{backgroundColor:'palegreen',color:'#333'}}/>
                </div>
            )
        },
        {
            title: '操作',
            dataIndex: 'operation',
            // key: 'id',
            align: 'right',
            width: '260px',
            render: (text, record) => (
                <div>
                    <Button size='small' type="primary" onClick={() => {
                        setShowFixModel(true)
                        dispatchArea({ type: 'update', area: record })
                    }}>
                        修改
                    </Button>
                    <Button size='small' type='primary' danger style={{ marginLeft: '10px' }} onClick={() => {
                        Modal.confirm({
                            centered: true,
                            title: `确定要删除区域${record.name}吗？`,
                            icon: <ExclamationCircleOutlined />,
                            content: `区域${record.name}删除之后将不可恢复！！`,
                            okText: '删除',
                            okType: 'danger',
                            cancelText: '取消',
                            onOk() {
                                http.delete("/v1/district/" + record.id, { data: record }).then((data) => {
                                    if (data.code === 0) {
                                        http.get("/v1/district", {}).then(data => {
                                            if (data.code === 0) {
                                                dispatch({ type: 'district', district: data.data })
                                            }
                                        })
                                    }
                                })
                            },
                            onCancel() {
                                console.log('Cancel');
                            },
                        });
                        
                    }}>
                        删除
                    </Button>
                    {
                        state.main.type <103&&Mode==='soc'&&
                        <Button size='small' type='primary'
                        style={{ backgroundColor: 'green', color: '#fff',  marginLeft: '10px' }}
                            onClick={() => {
                                dispatchDevice({ type: 'clear', district: record.id});
                                setShowNewDevModel(true);                 
                            }}>新建设备
                        </Button>
                    }
                </div>
            ),
        },
    ]
    const onfinish = (values) => {
        const {cardedittime,simauto,cardedittimeauto,iccid1,simdate,...newvalues} = values
        http.post("/v1/device", {
            ...newvalues,
            parent:'',
            district:actDevice.district,
            node: Number(values.node),
            sn: Number(values.sn),
            humi: values.humi ? 1 : 0,
            door_alarm: values.door_alarm ? 1 : 0,
            power_alarm: values.power_alarm ? 1 : 0,
            hide: values.hide ? 1 : 0,
            status: values.status ? 1 : 0,
            expire: values.expire.format("YYYY-MM-DD 00:00:00"),
            time: values.time.format("YYYY-MM-DD 00:00:00"),
            iccid_expire:values.iccid_expire ? values.iccid_expire.format("YYYY-MM-DD 00:00:00"):actDevice.iccid_expire+' 00:00:00',
        })

    }
    return (
        <div  style={{height:'100%',padding: 10,backgroundColor:'#fff',position:'relative' }}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:10,border:'1px solid #ccc',borderRadius:5,padding:10}}>
                <div>{Mode==='soc'&&props.userInfo.name}</div>
                <Button onClick={() => {
                    setShowNewModel(true)
                    dispatchArea({ type: 'clear'})
                }}>新建区域</Button>
            </div>
            <Table bordered pagination={{ hideOnSinglePage: true }} rowKey={record => record.id} columns={columns} size='small' dataSource={state.district.filter(x => { return ((props.userInfo && x.user === props.userInfo.id) || (!props.userInfo))&&x.id > 0 })} 
                scroll={{y:state.resolution.height<800?420:state.resolution.height<1000?550:700}}/>
            <Modal maskClosable={false} title="新增区域" visible={showNewModel} 
                destroyOnClose
                cancelText='取消'
                okText='确定'
                onOk={() => {
                    if(actArea.name==='') return
                    http.post("/v1/district", { ...actArea, user: Mode==='soc'?props.userInfo.id : 1 }).then((data) => {
                        if (data.code === 0) {
                            http.get("/v1/district", {}).then(data => {
                                if (data.code === 0) {
                                    dispatch({ type: 'district', district: data.data })
                                }
                            })

                            setShowNewModel(false)
                        } else {
                            Modal.error({
                                title: data.code,
                                content: data.msg,
                            });
                        }
                    })
                    
                }}
                onCancel={() => {
                    setShowNewModel(false)
                }}>
                <AreaContext.Provider value={{ actArea, dispatchArea }}>
                    <AreaNew />
                </AreaContext.Provider>
            </Modal>
            <Modal maskClosable={false} title="修改区域" visible={showFixModel}
                destroyOnClose
                cancelText='取消'
                okText='确定'
                onOk={() => {

                    http.put("/v1/district/" + actArea.id, { ...actArea, user:Mode==='soc'? props.userInfo.id :1 }).then((data) => {
                        if (data.code === 0) {
                            http.get("/v1/district", {}).then(data => {
                                if (data.code === 0) {
                                    dispatch({ type: 'district', district: data.data })
                                }
                            })
                        }
                    })

                    setShowFixModel(false)
                }}
                onCancel={() => {
                    setShowFixModel(false)
                }}>
                <AreaContext.Provider value={{ actArea, dispatchArea }}>
                    <AreaNew />
                </AreaContext.Provider>
            </Modal>
            <Modal maskClosable={false} title="新增设备" visible={showNewDevModel}
                destroyOnClose
                cancelText='取消'
                width={600}
                okText='确定'
                onOk={() => {
                    form.submit();
                    setShowNewDevModel(false)
                }}
                onCancel={() => {
                    setShowNewDevModel(false)
                    dispatchDevice({ type: 'clear'})
                }}>
                <DeviceContext.Provider value={{ actDevice, dispatchDevice, form, onfinish }}>
                    <DeviceNew isShowUser={false} />
                    
                </DeviceContext.Provider>
            </Modal>
            <Modal maskClosable={false} title={
                <div style={{display:'flex',justifyContent:'center',alignItems:'center',paddingLeft:30,paddingRight:30,paddingTop:10}}>
                    <div><span style={{fontSize:30}}>设 备 管 理</span></div>
                    {/* <div><span>用户名称: </span>{actArea.user_name}</div> */}
                    {/* <div><span>区域名称: </span>{actArea.name}</div> */}
                </div>} 
                style={{ top: 20 }}
                visible={devMangerModel}
                destroyOnClose
                footer={null}
                width={2000}
                onCancel={() => {
                    setDevMangerModel(false)
                }}>
                <AreaContext.Provider value={{actArea,dispatchArea }}>
                    <DeviceManage />
                </AreaContext.Provider>
            </Modal>
        </div>
    )
}

export default AreaManage